<template>
    <div>
        <div v-if="suppliers_loading_status == true" class="text-center">
            <b-spinner small type="grow"></b-spinner>
            Loading...
        </div>
        <div v-else-if="client_suppliers.length > 0" class="mt-3">
            <webix-ui :config="ui" v-model="client_suppliers_data"></webix-ui>
            <div id="suppliersTablePaging"></div>
        </div>
        <div v-else-if="suppliers_loading_status == false" class="mt-3">This client has no suppliers</div>
        <div v-else-if="suppliers_selected_client == null" class="mt-3">
            Select a client on the collection list, to view their respective suppliers
        </div>
        <div v-else class="mt-3">Something went wrong...</div>
    </div>
</template>

<script>
import { adminComputed, adminMethods, suppliersComputed, suppliersMethods } from "@/state/helpers";

//eslint-disable-next-line
import Swal from "sweetalert2";
import { cloneDeep } from "lodash";

export default {
    components: {},
    data: () => ({
        resize_event: null,
        updated_rows: [],
        validation_message: "",
        edit_flag: true,
    }),
    computed: {
        ...adminComputed,
        ...suppliersComputed,
        client_suppliers_data() {
            return cloneDeep(this.client_suppliers);
        },
        ui() {
            //eslint-disable-next-line
            let el = this;

            let ui = {
                id: "suppliersTable",
                view: "datatable",
                css: "datatableUsers webix_header_border webix_data_border datatableHover",
                autoheight: true,
                // hover: "datatableHover",
                // select: "cell",
                // hover: "suppliersTableHoverRow",
                editaction: "dblclick",
                minHeight: 60,
                // minColumnWidth: 120,
                rowHeight: 35,
                scrollY: false,
                scrollX: true,
                resizeColumn: true,
                editable: true,
                columns: [
                    {
                        id: "actions",
                        header: [{ text: "Actions", css: { "text-align": "center" } }],
                        template: function() {
                            return `
                                <div class="tableIcons">
                                    <i v-b-tooltip.hover title="View Suppliers Certificates" class="bx bx-list-check certificateListAction"></i>
                                </div>`;
                        },
                    },
                    {
                        id: "supplier_no",
                        header: ["Supplier No", { content: "textFilter" }],
                        tooltip: false,
                        // editor: "text", ! Christiaan not using this at backend
                        fillspace: 1,
                        sort: "string",
                    },
                    {
                        id: "supplier_name",
                        header: ["Supplier Name", { content: "textFilter" }],
                        tooltip: false,
                        editor: "text",
                        fillspace: 1,
                        sort: "string",
                    },
                    {
                        id: "expiry_date",
                        header: ["Expiry Date", { content: "textFilter" }],
                        fillspace: 1,
                        sort: "string",
                        // editor: "date",
                        template: function(obj) {
                            // return obj.expiry_date;

                            if (obj.expiry_date == null) {
                                return "-";
                            }

                            return obj.expiry_date.substring(0, 10);
                        },
                    },
                    {
                        id: "bbbee_level",
                        header: ["BEE Level", { content: "selectFilter", options: ["1", "2", "3", "4", "5", "6", "7", "8", "0"] }],
                        fillspace: 1,
                        sort: "int",
                        // editor: "select",
                        // options: ["1", "2", "3", "4", "5", "6", "7", "8", "0"],
                        template: function(obj) {
                            // return obj.expiry_date;

                            if (obj.bbbee_level == null) {
                                return "-";
                            }

                            return obj.bbbee_level;
                        },
                    },
                    {
                        id: "vat_no",
                        header: ["VAT No.", { content: "textFilter" }],
                        fillspace: 1,
                        sort: "string",
                        editor: "text",
                    },
                    {
                        id: "company_reg",
                        header: ["Company Reg No.", { content: "textFilter" }],
                        fillspace: 1,
                        sort: "string",
                        editor: "text",
                    },
                    {
                        id: "contact_no",
                        header: ["Contact No.", { content: "textFilter" }],
                        fillspace: 1,
                        sort: "string",
                        editor: "text",
                    },
                    {
                        id: "contact_person",
                        header: ["Contact Person", { content: "textFilter" }],
                        fillspace: 1,
                        sort: "string",
                        editor: "text",
                    },
                    {
                        id: "email",
                        header: ["Email", { content: "textFilter" }],
                        fillspace: 1,
                        sort: "string",
                        editor: "text",
                    },
                    {
                        id: "address",
                        header: ["Address", { content: "textFilter" }],
                        fillspace: 2,
                        sort: "string",
                        editor: "text",
                    },
                ],
                rules: {
                    vat_no: el.vatNumber,
                    company_reg: el.companyReg,
                    supplier_no: el.supplierNo,
                    supplier_name: el.supplierName,
                    contact_no: el.contacNo,
                    contact_person: el.contactPerson,
                    email: el.email,
                    address: el.address,
                },
                ready() {
                    // this.markSorting("company_name", "desc");
                    // el.resize_event = window.webix.event(window, "resize", function() {
                    //     el.$nextTick(() => {
                    //         window.webix.$$(el.ui.id).refresh();
                    //     });
                    // });
                },
                on: {
                    //eslint-disable-next-line
                    onValidationError: function(id, obj, details) {},
                    onBeforeLoad: function() {
                        this.showOverlay("Loading...");
                    },
                    onAfterLoad: function() {
                        this.hideOverlay();
                    },
                    //eslint-disable-next-line
                    onCheck: function(editor, state, obj) {
                        let el = this.$scope.$parent;

                        if (obj == 1) {
                            el.addSuppliersToDeleteIds(editor);
                        }

                        if (obj == 0) {
                            el.removeSuppliersToDeleteIds(editor);
                        }
                    },
                    //eslint-disable-next-line
                    onDataUpdate(id, data, old) {
                        let objToEmit = {
                            id: id,
                            vat_no: null,
                            company_reg: null,

                            supplier_no: null,
                            supplier_name: null,
                            contact_no: null,
                            contact_person: null,
                            email: null,
                            address: null,
                        };

                        el.supplierNo(data.supplier_no) == false ? (objToEmit.supplier_no = false) : (objToEmit.supplier_no = true);

                        el.vatNumber(data.vat_no) == false ? (objToEmit.vat_no = false) : (objToEmit.vat_no = true);

                        el.companyReg(data.company_reg) == false ? (objToEmit.company_reg = false) : (objToEmit.company_reg = true);

                        el.supplierName(data.supplier_name) == false ? (objToEmit.supplier_name = false) : (objToEmit.supplier_name = true);

                        el.contacNo(data.contact_no) == false ? (objToEmit.contact_no = false) : (objToEmit.contact_no = true);

                        el.contactPerson(data.contact_person) == false ? (objToEmit.contact_person = false) : (objToEmit.contact_person = true);

                        el.email(data.email) == false ? (objToEmit.email = false) : (objToEmit.email = true);

                        el.address(data.address) == false ? (objToEmit.address = false) : (objToEmit.address = true);

                        el.$emit("handleChangedRow", objToEmit);
                    },
                },

                onClick: {
                    //eslint-disable-next-line
                    qcAction: function(id, e, trg) {
                        let item = this.getItem(e.row);
                        let el = this.$scope.$parent;

                        //set the selected suppliers details
                        el.setSupplierDetails(item);

                        el.$emit("handleModal", "dataQCModal");
                    },
                    //eslint-disable-next-line
                    certificateListAction: function(id, e, trg) {
                        let item = this.getItem(e.row);
                        let el = this.$scope.$parent;

                        el.setSupplierDetails(item);
                        el.setSupplierCertificates(el.selected_supplier_details.id);

                        el.$emit("handleModal", "certificateListModal");
                    },
                },
            };

            //pager
            if (this.client_suppliers.length > 15) {
                ui.pager = {
                    template: "{common.prev()} {common.pages()} {common.next()}",
                    container: "suppliersTablePaging",
                    css: { width: "100% !important" },
                    size: 15,
                    group: 5,
                };
            }

            //checks to see if permission to delete, will then inject textboxes in the table
            if (this.findPermission("Delete Suppliers") || this.isTypeUser) {
                ui.columns.splice(1, 0, {
                    id: "checkbox",
                    header: { content: "masterCheckbox" },
                    template: "{common.checkbox()}",
                    width: 40,
                });
            }

            return ui;
        },
    },
    methods: {
        ...adminMethods,
        ...suppliersMethods,

        vatNumber(value) {
            if (value.length == 10 || value.length == 0) {
                return true;
            }
            return false;
        },
        companyReg(value) {
            if (value.length == 14 || value.length == 0) {
                return true;
            }
            return false;
        },
        supplierNo(value) {
            if (value.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        supplierName(value) {
            if (value.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        contacNo(value) {
            if (value.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        contactPerson(value) {
            if (value.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        email(value) {
            if (value.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        address(value) {
            if (value.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        handleRoute() {
            //eslint-disable-next-line
            // if (this.suppliers_client_details.client_id !== null || this.$route.params.client_id !== null) {
            // console.log("there is no client id", this.suppliers_client_details.client_id, this.$route.params.client_id);

            if (this.$route.fullPath == "/collectionslist/client") {
                this.$router.push({
                    path: `/collectionslist/client/${this.suppliers_client_details.client_id}`,
                });
            } else {
                //eslint-disable-next-line
                //console.log("is there an ID", this.$route.params.client_id);
                this.setSuppliers(this.$route.params.client_id);
            }
            // }
        },
    },
    mounted() {
        this.handleRoute();

        if (this.suppliers_selected_client == null) {
            //set the api here
        }

        //this will remove the checkboxes
        if (window.webix.$$(this.ui.id)) {
            window.webix.$$(this.ui.id).refresh();
        }
    },
};
</script>

<style lang="scss">
.suppliersTableHoverRow {
    background: #556ee6;
    cursor: default;
}
.highlighted-row {
    background-color: yellow; /* You can adjust the highlight style here */
}
</style>
